require('./aggregatorAddEntity.scss')

// @vendors
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @actions
import {
    clearAddEntity,
    getBanks,
    selectBank,
    setVisibleStep,
    validateStep,
    setWillCancel,
    getDataBank,
    setFormValue,
    sendFormInfo,
    clearFormValues,
    handleTermsAndConditions,
} from 'actions/aggregator/aggregatorAddEntity';
import { getEntitiesData } from  'actions/aggregator/aggregatorData';

import { requestUrl, initStorePSD2 } from 'actions/aggregator/aggregatorAddEntityPSD2';

// @components
import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import { AggregatorAddEntityStepSelectBank } from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepSelectBank/aggregatorAddEntityStepSelectBank'
import { AggregatorAddEntityStepLogin } from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepLogin/aggregatorAddEntityStepLogin'
import AggregatorAddEntityModal from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityModal/aggregatorAddEntityModal'
import AggregatorAddEntityStepPSD2 from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepPSD2/aggregatorAddEntityStepPSD2';
import CustomFinalButton from './customFinalButton/customFinalButton';
import InsertEntityCredentialsSuccessView from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityCredentials/insertEntityCredentialsSuccessView';
import InsertEntityCredentialsErrorView from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityCredentials/insertEntityCredentialsErrorView';
import OKModal from 'commonsComponents/OKModal';
import AggregatorInfo from 'components/aggregator/aggregatorInfo/AggregatorInfo';

// @utilities
import { isFormFilled } from 'utilities/aggregator/aggregatorFormHelper'
import Storage from 'utilities/storage';
import UrlHelper from 'utilities/urlHelper';
const { formatText } = require('core/i18n').i18n;

// @constants
import { recordLink, PROC_ADD_ENTITY, PROC_ADD_ENTITY_ERROR, PROC_RESTART } from 'utilities/tagging';
import { SELECTED_BANK, PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
import { CREATE_CONSENT } from 'constants/aggregator/psd2DecoupledFlowType';
const { AGGREGATOR_NEW_FEATURES, AGGREGATOR_PSD2, AGGREGATOR_CONSENTS } = require('constants/flagBasedFeatures');
const TRANSLATION_KEY_PREFIX = 'aggregatorAddEntity';

class AggregatorAddEntityClass extends React.PureComponent {

    componentDidMount() {
        this.props.getEntitiesData();
    }

    componentWillUnmount(){
        this.props.clearAddEntity()
    }

    renderSecondWizardStep = () => {
        const {
            immAggregatorAddEntity,
            getDataBank,
            setFormValue,
            clearFormValues,
        } = this.props;

        const immStep = immAggregatorAddEntity.getIn(['steps', 0], {})
        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1])
        const finalButtonText = TRANSLATION_KEY_PREFIX + '-finalButton';
        const name = immStep ? immStep.getIn(['selectedBank', 'text']) : ''
        const url = immStep ? immStep.getIn(['selectedBank', 'url']) : ''

        return (
            <WizardStep
                cancelButton={true}
                position="last"
                previousButton={true}
                finishButton={true}
                immFinalButton={finalButtonText}
                finalButtonDisabled={!isFormFilled(immLoginStep.get('form'), immAggregatorAddEntity.get('values'))}
            >
                <AggregatorAddEntityStepLogin
                    getDataBank={getDataBank}
                    form={immLoginStep.get('form')}
                    beta={immLoginStep.get('beta')}
                    setFormValue={setFormValue}
                    clearFormValues={clearFormValues}
                    bankId={immStep.getIn(['selectedBank', 'id'])}
                    bankUniqueId={immStep.getIn(['selectedBank', 'id'])}
                    isFetching={immLoginStep.get('isFetching')}
                    name={name}
                    url={url}
                    values={immAggregatorAddEntity.get('values')}
                    submitFetching={immLoginStep.get('fetchingform')}
                />
            </WizardStep>
        )
    }

    renderPSD2SecondWizardStep = () => {
        const {
            immAggregatorAddEntity,
            getDataBank,
            requestUrl,
            initStorePSD2,
            redirectionUrl,
        } = this.props;

        const immStep = immAggregatorAddEntity.getIn(['steps', 0], {})
        const name = immStep ? immStep.getIn(['selectedBank', 'text']) : ''
        const url = immStep ? immStep.getIn(['selectedBank', 'url']) : ''

        return (<WizardStep
            cancelButton={true}
            position="last"
            finishButton={true}
            overrides={{
                FinalButton: this.renderCustomFinalButton(name)
            }}>
            <AggregatorAddEntityStepPSD2
                getDataBank={getDataBank}
                bankId={immStep.getIn(['selectedBank', 'id'])}
                bankUniqueId={immStep.getIn(['selectedBank', 'id'])}
                name={name}
                url={url}
                requestUrl={requestUrl}
                initStorePSD2={initStorePSD2}
                redirectionUrl={redirectionUrl}
            />
        </WizardStep>)
    }

    renderCustomFinalButton = name => {
        const { immAggregatorAddEntity, isFetchingUrl, redirectionUrl } = this.props;
        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

        return (
            <CustomFinalButton onClick={() => this.handleOnClickCustomFinalButton(immLoginStep, redirectionUrl)} loading={isFetchingUrl}>
                {formatText('aggregatorPSD2-goToBankTextButton', [name])}
            </CustomFinalButton>
        )
    }

    handleOnClickCustomFinalButton = (immBankData, redirectionUrl = '') => {
        const { name, logo, code, psd2Info } = immBankData ? immBankData.toJS() : {};

        const scrapingCredentials = this.props.aggregatorData.getIn(['banks', code, 'scrapingCredentials']) || false;

        Storage.localStorage.set(SELECTED_BANK, {
            bankName: name,
            bankLogo: logo,
            bankCode: code,
            bankManagement: psd2Info.consentManagementMode,
            scrapingCredentials,
        })
        Storage.localStorage.set(PSD2_FLOW_TYPE, CREATE_CONSENT)

        UrlHelper.redirectToExternalURL(redirectionUrl)
    }

    shouldShowPsd2Flow = (isPsd2SupportedByBank, isAggregatorPsd2FeatureEnabled) =>
        isPsd2SupportedByBank && isAggregatorPsd2FeatureEnabled ? true : false;

    renderWizard = () => {
        const {
            getBanks,
            getDataBank,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onConfirmLeave,
            immAggregatorAddEntity,
            sendFormInfo,
            selectBank,
            immFlagBasedFeatures,
        } = this.props;

        const immStep = immAggregatorAddEntity.getIn(['steps', 0], {})
        const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1])

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: onConfirmLeave,
            finish: () => sendFormInfo(immLoginStep.get('publicKey'), immLoginStep.get('code'), immAggregatorAddEntity.get('values'))
        };

        const isAggregatorPsd2FeatureEnabled = immFlagBasedFeatures.get(AGGREGATOR_PSD2)
        const isPsd2SupportedByBank = immLoginStep.get('psd2Supported')

        return (
            <Wizard
                actions={actions}
                immSteps={immAggregatorAddEntity.get('steps')}
                visibleStep={immAggregatorAddEntity.get('visibleStep')}
                stepsAmount={2}
                isFetching={immAggregatorAddEntity.get('submitFetching')}
                wizardClass="aggregator-add-entity__wizard"
                processType={PROC_ADD_ENTITY}
                showPreLeaveModal={true}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    nextButtonDisabled={false}
                    isLoading={immLoginStep.get('isFetching')}
                >
                    <AggregatorAddEntityStepSelectBank
                        validateStep={validateStep}
                        getDataBank={getDataBank}
                        banks={immStep.get('banks')}
                        getBanks={getBanks}
                        selectedBank={immStep.getIn(['selectedBank', 'id'])}
                        selectBank={selectBank}
                        isFetching={immStep.get('isFetching')}
                    />
                </WizardStep>
                { this.shouldShowPsd2Flow(isPsd2SupportedByBank, isAggregatorPsd2FeatureEnabled) ?
                    this.renderPSD2SecondWizardStep() :
                    this.renderSecondWizardStep() }
            </Wizard>
        )
    }

    handleModalButtonClick = () => {
        this.props.clearAddEntity()
    }

    handleOnClickMainButton = () => {
        recordLink(PROC_ADD_ENTITY_ERROR, PROC_RESTART)
        this.props.clearAddEntity()
    }

    render(){
        const {immAggregatorAddEntity, handleTermsAndConditions, immFlagBasedFeatures, errorRedirectionUrl } = this.props
        const immStep = immAggregatorAddEntity.getIn(['steps', 0])
        const bankName = immStep ? immStep.getIn(['selectedBank', 'text']) : ''
        const bankLogo = immStep ? immStep.getIn(['selectedBank', 'url']) : ''
        const isSubmitSuccessful = immAggregatorAddEntity.get('submitSuccessful')
        const hasError = immAggregatorAddEntity.get('error') ||
            immAggregatorAddEntity.getIn(['steps', 0, 'error']) ||
            immAggregatorAddEntity.getIn(['steps', 1, 'error'])

        if (isSubmitSuccessful) {
            return (<InsertEntityCredentialsSuccessView
                bankName={bankName}
                bankLogo={bankLogo}
                onMainButtonClick={this.handleOnClickMainButton}/>);
        }

        if (hasError) {
            return (<InsertEntityCredentialsErrorView />)
        }

        return (
            <Fragment>
                {Object.keys(this.props.banks.toJS()).length === 0 &&<AggregatorAddEntityModal
                    showModal={Object.keys(this.props.banks.toJS()).length === 0}
                    immAggregatorAddEntity={immAggregatorAddEntity}
                    handleTermsAndConditions={handleTermsAndConditions}
                    newCategorized={immFlagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)}
                    newConsents={immFlagBasedFeatures.get(AGGREGATOR_CONSENTS)}
                />}
                <div className="aggregator-add-entity row">
                    <div className="col-xs-12 col-md-8">
                        {this.renderWizard()}
                    </div>
                    <div className="aggregator-add-entity__sidebar col-xs-12 col-md-4">
                        <AggregatorInfo />
                    </div>
                </div>
                <OKModal
                    isOpen={errorRedirectionUrl}
                    title={formatText('aggregatorPSD2-redirectionUrlErrorTitle')}
                    content={formatText('aggregatorPSD2-redirectionUrlErrorMessage')}
                    footerType="action"
                    primaryButtonText={formatText('aggregatorPSD2-redirectionUrlErrorButton')}
                    onPrimaryButtonClick={this.handleModalButtonClick}
                    customCloseButton={<div/>}
                />
            </Fragment>
        )
    }
}

AggregatorAddEntityClass.propTypes = {
    immAggregatorAddEntity: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onConfirmLeave: PropTypes.func.isRequired,
    sendFormInfo: PropTypes.func.isRequired,
    getBanks: PropTypes.func.isRequired,
    selectBank: PropTypes.func.isRequired,
    clearAddEntity: PropTypes.func.isRequired,
    setFormValue: PropTypes.func.isRequired,
    getDataBank: PropTypes.func.isRequired,
    clearFormValues: PropTypes.func,
    handleTermsAndConditions: PropTypes.func,
    getEntitiesData: PropTypes.func,
    showModal: PropTypes.bool,
    isFetching: PropTypes.bool,
    requestUrl: PropTypes.func,
    initStorePSD2: PropTypes.func,
    isFetchingUrl: PropTypes.bool,
    redirectionUrl: PropTypes.string,
    errorRedirectionUrl: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    aggregatorData: PropTypes.object,
    banks: PropTypes.object,
}


AggregatorAddEntityClass.defaultProps = {
    immAggregatorAddEntity: {},
    setVisibleStep: () => {},
    setWillCancel:() => {},
    validateStep: () => {},
    onConfirmLeave: () => {},
    getEntitiesData: () => {},
    sendFormInfo: () => {},
    getBanks: () => {},
    selectBank: () => {},
    clearAddEntity: () => {},
    setFormValue: () => {},
    getDataBank: () => {},
    handleTermsAndConditions: () => {},
    requestUrl: () => {},
    initStorePSD2: () => {},
    showModal: true,
    immFlagBasedFeatures: {}
}

const AggregatorAddEntity = connect(state => ({
    immAggregatorAddEntity: state.aggregatorAddEntity,
    isFetchingUrl: state.aggregatorAddEntityPSD2.get('isFetchingUrl'),
    redirectionUrl: state.aggregatorAddEntityPSD2.get('redirectionUrl'),
    errorRedirectionUrl: state.aggregatorAddEntityPSD2.get('error'),
    showModal: !state.aggregatorData.getIn(['data', 'banks'], {size: 0}).size,
    immFlagBasedFeatures: state.flagBasedFeatures,
    aggregatorData: state.aggregatorData.get('data'),
    banks: state.aggregatorData.getIn(['data', 'banks']),
}), {
    clearAddEntity,
    getBanks,
    selectBank,
    validateStep,
    sendFormInfo,
    setVisibleStep,
    setWillCancel,
    getDataBank,
    requestUrl,
    initStorePSD2,
    setFormValue,
    clearFormValues,
    handleTermsAndConditions,
    getEntitiesData
})(AggregatorAddEntityClass)

export { AggregatorAddEntity };
